module.exports = __webpack_public_path__ + "a2c680d466d0a55a9e08a76a3414c207.png";